import { PublishPlanGoodsCategory } from "./publish-plan-goods-category-list-info.model";

/**
 * 企画回別商品一覧画面の企画回別商品一覧情報クラス（編集可能項目のみ）
 *
 * @export PublishPlanGoodsCategoryListEditableInfo
 * @class PublishPlanGoodsCategoryListEditableInfo
 */
export class PublishPlanGoodsEditableCategory {
  pcode: string;
  itemCode: string;
  specialFeature: string;
  folio: string;
  edlp: string;
  buyerComment: string;
  coopFlg142: boolean;
  coopFlg163: boolean;
  coopFlg185: boolean;
  coopFlg240: boolean;
  coopFlg210: boolean;
  coopFlg302: boolean;
  coopFlg515: boolean;
  coopFlg451: boolean;
  coopEnabledFlg142: boolean;
  coopEnabledFlg163: boolean;
  coopEnabledFlg185: boolean;
  coopEnabledFlg240: boolean;
  coopEnabledFlg210: boolean;
  coopEnabledFlg302: boolean;
  coopEnabledFlg515: boolean;
  coopEnabledFlg451: boolean;
  pricePattern: string;
  pricePromotion: string;
  bargainMarkFlg: boolean;
  komaPromotion: string;
  promotionMark: string;
  appearDiv: string;
  orderNumQuotaCode: string;
  mediumWPublishFlg: boolean;
  crossCode: string;
  crossDecisionFlg: boolean;
  wCrossFlg: boolean;
  thisTimeSupplyPrice: string;
  thisTimeCostPrice: string;
  bundlePrice: string;
  planNum: string;
  wCarryingFlg: boolean;
  mainCoopCode: string;

  constructor(data){
    this.pcode = data.PCode;
    this.itemCode = data.ItemCode;
    this.specialFeature = data.SpecialFeature;
    this.folio = data.Folio;
    this.edlp = data.Edlp;
    this.buyerComment = data.BuyerComment;
    this.coopFlg142 = data.CoopFlg142 === '1';
    this.coopFlg163 = data.CoopFlg163 === '1';
    this.coopFlg185 = data.CoopFlg185 === '1';
    this.coopFlg240 = data.CoopFlg240 === '1';
    this.coopFlg210 = data.CoopFlg210 === '1';
    this.coopFlg302 = data.CoopFlg302 === '1';
    this.coopFlg515 = data.CoopFlg515 === '1';
    this.coopFlg451 = data.CoopFlg451 === '1';
    this.coopEnabledFlg142 = data.CoopEnabledFlg142 === '1';
    this.coopEnabledFlg163 = data.CoopEnabledFlg163 === '1';
    this.coopEnabledFlg185 = data.CoopEnabledFlg185 === '1';
    this.coopEnabledFlg240 = data.CoopEnabledFlg240 === '1';
    this.coopEnabledFlg210 = data.CoopEnabledFlg210 === '1';
    this.coopEnabledFlg302 = data.CoopEnabledFlg302 === '1';
    this.coopEnabledFlg515 = data.CoopEnabledFlg515 === '1';
    this.coopEnabledFlg451 = data.CoopEnabledFlg451 === '1';
    this.pricePattern = data.PricePattern;
    this.pricePromotion = data.PricePromotion;
    this.bargainMarkFlg = data.BargainMarkFlg === '1';
    this.komaPromotion = data.KomaPromotion;
    this.promotionMark = data.PromotionMark;
    this.appearDiv = data.AppearDiv;
    this.orderNumQuotaCode = data.OrderNumQuotaCode;
    this.mediumWPublishFlg = data.MediumWPublishFlg === '1';
    this.crossCode = data.CrossCode;
    this.crossDecisionFlg = data.CrossDecisionFlg;
    this.wCrossFlg = data.WCrossFlg === '1';
    this.thisTimeSupplyPrice = data.ThisTimeSupplyPrice;
    this.thisTimeCostPrice = data.ThisTimeCostPrice;
    this.bundlePrice = data.BundlePrice;
    this.planNum = data.PlanNum;
    this.wCarryingFlg = data.WCarryingFlg === '1';
    this.mainCoopCode = data.MainCoopCode;
  }
}